import type { ReactNode, VoidFunctionComponent } from 'react';

import Crumb from './Crumb';
import type { BreadCrumb } from './Crumb';

import styles from './PageHeadingBreadcrumbs.module.less';

type Props = {
  crumbs: BreadCrumb[];
  //  If supplied, this is the length at which a breadcrumb
  //  will be truncated at (with a Tooltip displayed). Defaults to `0` (no truncation).
  truncateAt?: number;
  //  What goes between two crumbs. Defaults to a "/".
  separator?: ReactNode;
};

/**
 * PageHeadingBreadcrumbs are big navigational links which
 * appear at the top of some pages, indicating where the user is
 * in relation to the page they are in (ie: `Packages / some-package / 1.2.3`).
 */
const PageHeadingBreadcrumbs: VoidFunctionComponent<Props> = ({
  crumbs,
  truncateAt = 0,
  separator = '/',
}) => (
  <div className={styles.container}>
    {crumbs.map((crumbProps, index) => {
      //  Skip the preceeding "/" for the first one
      if (index === 0) {
        // eslint-disable-next-line react/jsx-props-no-spreading -- It's fine.
        return <Crumb truncateAt={truncateAt} {...crumbProps} />;
      }
      return (
        <>
          <span className={styles.separator}>{separator}</span>
          {/* eslint-disable-next-line react/jsx-props-no-spreading -- It's fine. */}
          <Crumb truncateAt={truncateAt} {...crumbProps} />
        </>
      );
    })}
  </div>
);

export default PageHeadingBreadcrumbs;
